<p-toast></p-toast>
<!-- <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar> -->
<div class="col-12 my-3" *ngIf="farmerIDNotFound">
  <div class="d-flex justify-content-center" [style]="{color:'red'}">
    <p>{{'FARMER ID NOT FOUND'| translate}}</p>
  </div>
</div>

<div class="col-12">
  <div class="card" reflow="true">
    <h5>{{'FARMERS_APPLICATION'| translate}}</h5>

    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
      <div class="field md:col-6 col-12">
        <!-- <div class="mb-2"> -->
          <img src="../../../../assets/activitiesImages/newitem.gif">
          <span class="pr-2">Tubewell connection (UHBVN)</span>
        <!-- </div> -->
        <!-- <div> -->
          <p-inputSwitch ariaLabelledBy="switch2" (onChange)="onUHBVNToggle($event)" [(ngModel)]="isAppliedForUHBVN" [disabled]="showClearUHBVNButton || uhbvnToggleDisabledMode"></p-inputSwitch>
        <!-- </div> -->
      </div>

      <div *ngIf="isAppliedForUHBVN" class="field md:col-3 col-12">
        <input type="text" [disabled]="showClearUHBVNButton" pInputText placeholder="{{'UHBVN App Id'| translate}}" [(ngModel)]="tubewellAppId" />
      </div>

      <div *ngIf="isAppliedForUHBVN && tubewellAppId" class="field md:col-3 col-12">
        <button *ngIf="!showClearUHBVNButton" pButton pRipple type="button" label="{{'Verify with UHBVN'| translate}}" class="p-button-success" style="float: right;"
          (click)="validateUBVNAppId()"></button>
        <button *ngIf="showClearUHBVNButton" pButton pRipple type="button" label="{{'Reset'| translate}}" class="p-button-help" style="float: right;"
          (click)="clearUBVNAppId()"></button>      
      </div>
    </div>

    <!-- <div class="p-fluid p-formgrid grid">
      <div class="field col-12 md:col-6">
        <span id="switch2" class="">Remember Me</span>
        <p-inputSwitch ariaLabelledBy="switch2"></p-inputSwitch>
      </div>
      <div *ngIf="false" class="field col-12 md:col-6">
        <span id="switch2" class="">Remember Me</span>
        <p-inputSwitch ariaLabelledBy="switch2"></p-inputSwitch>
      </div>
    </div> -->

    <div *ngIf="!isAppliedForUHBVN || (isAppliedForUHBVN && tubewellAppId && isUHBVNAppIdFound)" class="p-fluid p-formgrid grid">
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'APPLICATION_SCHEME_TYPE'| translate}}</label>
        <p-dropdown (onChange)="onApplicationSchemeTypeSelected($event)" [options]="schemeTypeList"
          placeholder="{{'SELECT_SCHEME_TYPE'| translate}}" optionLabel="type" optionValue="type" [(ngModel)]="applicationSchemeType">
        </p-dropdown>
      </div>

      <!-- <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'APPLICATION_TYPE'| translate}}</label>
        <p-dropdown (onChange)="onApplicationTypeSelected($event)" [options]="schemeMasterList"
          placeholder="{{'SELECT_APPLICATION_TYPE'| translate}}" optionLabel="type" optionValue="type" [(ngModel)]="selectedApplicationType">
        </p-dropdown>
      </div> -->
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'APPLICATION_TYPE'| translate}}</label>
        <p-dropdown (onChange)="onApplicationTypeSelected($event)" [options]="applicationTypeList"
          placeholder="{{'SELECT_APPLICATION_TYPE'| translate}}" optionLabel="type" optionValue="value" [(ngModel)]="applicationSelected">
        </p-dropdown>

        <!-- <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.farmersName.errors.required">Farmer Name is required</div>
          </div> -->
      </div>

      <!-- village type -->
      <div *ngIf="applicationSchemeType && applicationSelected" class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'VILLAGE'| translate}}</label>
        <p-autoComplete placeholder="{{'VILAGE_SEARCH' | translate}}" id="dd" [dropdown]="true" [multiple]="false"
          [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)" field="VillageName"
          (onSelect)="onVillageSelect($event)" [(ngModel)]="selectedVillage"></p-autoComplete>
      </div>

      <!-- water source type -->
      <!-- <div class="field col-12 md:col-4" *ngIf="waterSourceTypeList?.length && isVillageSelected">
        <label htmlFor="waterSourceType">{{'WATER_SOURCE_TYPE'| translate}}</label>
        <p-dropdown [options]="WaterSourceTypeList" (onChange)="onWaterSourceTypeSelected($event)"
          placeholder="{{'SELECT_WATER_SOURCE_TYPE'| translate}}" optionLabel="waterSource" optionValue="waterSource"
          [(ngModel)]="selectedWatersourceType"></p-dropdown>
      </div> -->
      <div class="field col-12 md:col-4" *ngIf="newWaterSourceTypeList?.length && isVillageSelected">
        <label htmlFor="waterSourceType">{{'WATER_SOURCE_TYPE'| translate}}</label>
        <p-dropdown [options]="newWaterSourceTypeList" (onChange)="onWaterSourceTypeSelected($event)"
          placeholder="{{'SELECT_WATER_SOURCE_TYPE'| translate}}" optionLabel="Source_Name" optionValue="Source_Name"
          [(ngModel)]="selectedWatersourceType"></p-dropdown>
      </div>

      <!-- component -->
      <!-- <div class="field col-12 md:col-4" *ngIf="(componentList.length && selectedWatersourceType && showComponent)">
        <label htmlFor="waterSourceType">{{'COMPONENTS'| translate}}</label>
        <p-dropdown [options]="componentList" optionLabel="component" (onChange)="onComponentSelected($event)"
          placeholder="{{'SELECT_A_COMPONENT'| translate}}" [(ngModel)]="componentSelected"></p-dropdown>
      </div> -->
      <div class="field col-12 md:col-4" *ngIf="(newComponentList.length && selectedWatersourceType && showComponent)">
        <label htmlFor="waterSourceType">{{'COMPONENTS'| translate}}</label>
        <p-dropdown [options]="newComponentList" optionLabel="Component" (onChange)="onComponentSelected($event)"
          placeholder="{{'SELECT_A_COMPONENT'| translate}}" [(ngModel)]="componentSelected"></p-dropdown>
      </div>

      <!-- if target reached  -->
      <div class="field col-12 md:col-12" *ngIf="isTargetReached">
        <p [style]="{'color': 'red'}"><b>{{ 'TARGET_REACHED_FOR_THE_SELECTED_VILLAGE._YOU_CANNOT_PROCEED_FURTHER.' | translate}}</b></p>
      </div>

    </div>
  </div>
  <div class="card" reflow="true" *ngIf="applicationSelected === 'Group' || applicationSelected === 'WUA'">
    <div class="p-fluid p-formgrid grid">
      <!-- add farmer in group -->
      <div class="field col-12 md:col-12">
        <p-toolbar styleClass="mb-4">
          <ng-template pTemplate="left">
            <button pButton icon="pi pi-fw pi-plus" label="{{'ADD_FARMERS_IN_GROUP'| translate}}" class="p-button-success"
              (click)="addFarmersInGroup()"></button>

            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
          </ng-template>
          <ng-template pTemplate="right">
            <button class="mr-1" *ngIf="consentUploadPath" pButton pRipple label="{{'UPLOADED_CONSENT'| translate}}" icon="pi pi-plus"
              class="p-button-help mr-2" (click)="openPreviousConsent(consentUploadPath)"></button>

            <button class="mr-1" *ngIf="applicationSelected === 'Group'" pButton pRipple label="{{'NEW_CONSENT_FORM'| translate}}"
              icon="pi pi-plus" class="p-button-help mr-2" (click)="downloadConsent()"></button>

            <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" *ngIf="applicationSelected === 'Group'" mode="basic" [maxFileSize]="5000000"
              label="Upload" chooseLabel="Upload" class="ml-2 inline-block"></p-fileUpload> -->

            <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerApplicationConsentPathUpload
              (uploadHandler)="onUpload($event, 'consentForm', farmerApplicationConsentPathUpload)" name="myfile[]"
              mode="basic" [maxFileSize]="5000000" chooseLabel="Upload" [auto]="true">
            </p-fileUpload>
            <!-- <button  pButton pRipple label="Upload Consent" icon="pi pi-upload" class="p-button-help"></button> -->
          </ng-template>
        </p-toolbar>

        <p-table class="mt-2" #dt [value]="selectedFarmersLandList" [rows]="10" [paginator]="true"
          [globalFilterFields]="['farmer_Id','farmersName','landId', 'village']" responsiveLayout="scroll"
          [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true">
          <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
              <h5 class="m-0">{{'MANAGE_FARMERS_LIST'| translate}}</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                  placeholder="{{'SEARCH'| translate}}" />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>

              <th pSortableColumn="farmer_Id">{{'FARMER_ID'| translate}}
                <p-columnFilter type="text" field="farmer_Id" display="menu"></p-columnFilter>
                <p-sortIcon field="farmer_Id"></p-sortIcon>
              </th>
              <th pSortableColumn="farmersName">{{'FARMERS_NAME'| translate}}
                <p-columnFilter type="text" field="farmersName" display="menu"></p-columnFilter>
                <p-sortIcon field="farmersName"></p-sortIcon>
              </th>
              <th pSortableColumn="landId">{{'LAND_ID'| translate}}
                <p-columnFilter type="text" field="landId" display="menu"></p-columnFilter>
                <p-sortIcon field="landId"></p-sortIcon>
              </th>
              <th pSortableColumn="village">{{'VILLAGE'| translate}}
                <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                <p-sortIcon field="village"></p-sortIcon>
              </th>
              <th>{{ "ACTION" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product>
            <tr>

              <td>{{product.farmer_Id}}</td>
              <td>{{product.farmersName}}</td>
              <td>{{product.landID}}</td>
              <td>{{product.village}}</td>
              <!-- <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating> -->
              <!-- <td><span
                  [class]="'product-badge status-' + (product.inventoryStatus ? product.inventoryStatus.toLowerCase() : '')">{{product.inventoryStatus}}</span>
              </td> -->
              <td>
                <button *ngIf="(!isEditMode) || (isEditMode && product?.isEditableMode == true)" pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                  (click)="editFarmersInGroup(product)"></button>

                <button *ngIf="isEditMode && product?.isEditableMode == false" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                  (click)="deleteFarmersInGroup(product)"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
              {{'IN_TOTAL_THERE_ARE'| translate}}
              {{selectedFarmersLandList ? selectedFarmersLandList.length : 0 }} {{'FARMERS_ADDED'| translate}}.
            </div>
          </ng-template>
        </p-table>

      </div>
    </div>
  </div>

  <div class="card" reflow="true" *ngIf="(selectedWatersourceType == 'Canal' || selectedWatersourceType == 'STP') && showWaterCourseForm">
    <!-- <h5>{{'WATER_COURSE_FORM'| translate}}</h5> -->
    <!-- <div class="p-fluid p-formgrid grid"> -->
    <form [formGroup]="watercourseApplicatonForm" class="p-fluid p-formgrid grid">
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'Canal/ STP'| translate}}</label>
        <p-dropdown [options]="canalOutletList" formControlName="canal" optionLabel="canal" optionValue="canal"
          (onChange)="onCanalOutletSelected($event)" placeholder="{{'SELECT_CANAL'| translate}}" [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedWaterCourseFrom && watercourseFormControls.canal.errors || watercourseFormControls.canal.touched && watercourseFormControls.canal.errors}"></p-dropdown>
        <div *ngIf="isSubmittedWaterCourseFrom && watercourseFormControls.canal.errors || watercourseFormControls.canal.touched && watercourseFormControls.canal.errors"
          class="invalid-feedback">
          <div *ngIf="watercourseFormControls.canal.errors.required">
            {{'CANAL_IS_REQUIRED'| translate}}
          </div>
        </div>
      </div>
      <div class="field col-12 md:col-4" *ngIf="outletTypeList?.length">
        <label htmlFor="waterSourceType">{{'Outlet RD'| translate}}</label>
        <p-dropdown [options]="outletTypeList" formControlName="outlet" optionLabel="outletName" optionValue="recordID"
          placeholder="{{'SELECT_A_OUTLET'| translate}}" [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedWaterCourseFrom && watercourseFormControls.outlet.errors || watercourseFormControls.outlet.touched && watercourseFormControls.outlet.errors}"></p-dropdown>
          <div *ngIf="isSubmittedWaterCourseFrom && watercourseFormControls.outlet.errors || watercourseFormControls.outlet.touched && watercourseFormControls.outlet.errors"
          class="invalid-feedback">
          <div *ngIf="watercourseFormControls.outlet.errors.required">
            {{'OUTLET_IS_REQUIRED'| translate}}
          </div>
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'WORK_TYPE'| translate}}</label>
        <p-dropdown [options]="workTypeMasterList" formControlName="workType" optionLabel="workType"
          optionValue="workTypeID" placeholder="{{'SELECT_A_WORK_TYPE'| translate}}" [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedWaterCourseFrom && watercourseFormControls.workType.errors || watercourseFormControls.workType.touched && watercourseFormControls.workType.errors }"></p-dropdown>
          <div *ngIf="isSubmittedWaterCourseFrom && watercourseFormControls.workType.errors || watercourseFormControls.workType.touched && watercourseFormControls.workType.errors"
          class="invalid-feedback">
          <div *ngIf="watercourseFormControls.workType.errors.required">
            {{'WORKTYPE_IS_REQUIRED'| translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-12">
        <div class="field-checkbox mb-0">
          <p-checkbox name="group1" value="true" formControlName="checkBox" id="ch" [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedWaterCourseFrom && watercourseFormControls.checkBox.errors || watercourseFormControls.checkBox.touched && watercourseFormControls.checkBox.errors }"></p-checkbox>
          <label for="ch">{{'IAGREE_WITH_ALL_TERM_&_CONDITION'| translate}}</label>
        </div>
        <div *ngIf="isSubmittedWaterCourseFrom && watercourseFormControls.checkBox.errors || watercourseFormControls.checkBox.touched && watercourseFormControls.checkBox.errors"
          class="invalid-feedback">
          <div *ngIf="watercourseFormControls.checkBox.errors.required">
            {{'SELECT_CHECKBOX'| translate}}
          </div>
        </div>
      </div>
      <!-- </div> -->
    </form>
    <!-- </div> -->
  </div>

  <div class="card" reflow="true" *ngIf="(selectedWatersourceType == 'Over Flow Pond') && showWaterCourseForm">
    <h5>{{'OVERFLOW_POND'| translate}}</h5>
    <!-- <div class="p-fluid p-formgrid grid"> -->
    <form [formGroup]="overFlowPondApplicatonForm" class="p-fluid p-formgrid grid">
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'OVERFLOW_POND'| translate}}</label>
        <p-dropdown [options]="overFlowPondList" formControlName="overFlowPond" optionLabel="Name" optionValue="recordID"
          placeholder="{{'SELECT_OVERFLOW_POND'| translate}}" [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedOverFlowPondForm && overFlowPondFormControls.overFlowPond.errors || overFlowPondFormControls.overFlowPond.touched && overFlowPondFormControls.overFlowPond.errors}"></p-dropdown>
        <div *ngIf="isSubmittedOverFlowPondForm && overFlowPondFormControls.overFlowPond.errors || overFlowPondFormControls.overFlowPond.touched && overFlowPondFormControls.overFlowPond.errors"
          class="invalid-feedback">
          <div *ngIf="overFlowPondFormControls.overFlowPond.errors.required">
            {{'OVERFLOW_POND_IS_REQUIRED'| translate}}
          </div>
        </div>
      </div>
    </form>
  </div>


  <div class="card" reflow="true" *ngIf="componentSelected?.Component?.includes('MI')">
    <h5>{{'MI_FORM'| translate}}</h5>
    <button pButton icon="pi pi-fw pi-plus" label="{{'ADD_MI_DETAILS'| translate}}" (click)="openNew()"
      class="p-button-success mb-4"></button>

    <p-table class="mt-2" #dt [value]="miDetailsList" [rows]="10" [paginator]="true"
      [globalFilterFields]="['mi','vendor','landData', 'totalArea']" responsiveLayout="scroll"
      [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
      currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}" [showCurrentPageReport]="true">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <h5 class="m-0">{{'MANAGE_MI_LIST'| translate}}</h5>
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
              placeholder="{{'SEARCH'| translate}}" />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="mi">{{'COMPONENT'| translate}}
            <p-columnFilter type="text" field="mi" display="menu"></p-columnFilter>
            <p-sortIcon field="mi"></p-sortIcon>
          </th>
          <th pSortableColumn="vendor">{{'VENDOR'| translate}}
            <p-columnFilter type="text" field="vendor" display="menu"></p-columnFilter>
            <p-sortIcon field="vendor"></p-sortIcon>
          </th>
          <th pSortableColumn="landId">{{'LAND_ID'| translate}}
            <p-columnFilter type="text" field="landId" display="menu"></p-columnFilter>
            <p-sortIcon field="landId"></p-sortIcon>
          </th>
          <th pSortableColumn="totalArea">{{'TOTAL_AREA_ACRE'| translate}}
            <p-columnFilter type="text" field="totalArea" display="menu"></p-columnFilter>
            <p-sortIcon field="totalArea"></p-sortIcon>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <!-- <td>{{product | json}}</td> -->
          <td>{{product.mi}}</td>
          <td>{{product.vendor}}</td>
          <td>{{product.landData}}</td>
          <td>{{product.totalArea}}</td>
          <td>
            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
              (click)="editProduct(product)"></button>

            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
              (click)="deleteProduct(product)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          {{'IN_TOTAL_THERE_ARE'| translate}}
          {{miDetailsList ? miDetailsList.length : 0 }} {{'COMPONENT_DETAILS_ADDED'| translate}}.
        </div>
      </ng-template>
    </p-table>
    <!-- </div> -->

<div class="col-12">
    <div class="p-fluid p-formgrid grid">
      <div class="field col-12 md:col-4">
        <label htmlFor="Totalarea">{{'TOTAL_APPLICATION_AREA'| translate}}</label>
        <input pInputText id="Totalarea" [value]="getTotalSubsidyArea()" class="form-control" type="text" 
        autofocus="" tabindex="1" readonly />
      </div>
      <div class="field col-12 md:col-4">
          <label htmlFor="currentArea">{{'CURRENT_APPLIED_AREA'| translate}}</label>
          <input pInputText id="currentArea" [value]="getCurrentSubsidyArea()" class="form-control" type="text" 
          autofocus="" tabindex="1" readonly />
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="previousArea">{{'PREVIOUS_SUBSIDY'| translate}}</label>
          <input pInputText id="previousArea" [value]="getPreviousSubsidyArea()" class="form-control" type="text" 
      autofocus="" tabindex="1" readonly />
        </div>
    </div>
</div>
</div>
  <div class="card" reflow="true" *ngIf="componentSelected?.Component?.includes('Tank')">
    <h5>{{'POND_FORM'| translate}}</h5>
    <!-- <div class="p-fluid p-formgrid grid"> -->
    <form [formGroup]="onFarmPondApplicatonForm" class="p-fluid p-formgrid grid">
      <!-- <div class="col-12 flex-wrap" > -->
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'LAND_ID'| translate}} </label>
        <!-- <p-dropdown [options]="landIDList" formControlName="landId" optionLabel="displayName" optionValue="Land_ID" (onChange)="onPondLandIdSelected($event)" [(ngModel)]="selectedPondLand"
          placeholder="select  Land IDs"></p-dropdown> -->
        <p-dropdown [options]="landIDList" formControlName="landId" optionLabel="displayName" optionValue="LandID"
          placeholder="{{'SELECT_LAND_IDS'| translate}}" [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedPondApplicatonForm && farmPondApplicatonFormControls.landId.errors || farmPondApplicatonFormControls.landId.touched && farmPondApplicatonFormControls.landId.errors}"></p-dropdown>
        <div *ngIf="isSubmittedPondApplicatonForm && farmPondApplicatonFormControls.landId.errors || farmPondApplicatonFormControls.landId.touched && farmPondApplicatonFormControls.landId.errors"
          class="invalid-feedback">
          <div *ngIf="farmPondApplicatonFormControls.landId.errors.required">
            {{'LAND_ID_IS_REQUIRED'| translate}}
          </div>
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'TANK_TYPE'| translate}}</label>
        <p-dropdown [options]="tankTypeMaster" (onChange)="onSelectedTankType($event)"
          formControlName="tankType" optionLabel="Type" placeholder="{{'SELECT_TANK_TYPE'| translate}}" 
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedPondApplicatonForm && farmPondApplicatonFormControls.tankType.errors || farmPondApplicatonFormControls.tankType.touched && farmPondApplicatonFormControls.tankType.errors}"> 
        </p-dropdown>
        <div *ngIf="isSubmittedPondApplicatonForm && farmPondApplicatonFormControls.tankType.errors || farmPondApplicatonFormControls.tankType.touched && farmPondApplicatonFormControls.tankType.errors"
          class="invalid-feedback">
          <div *ngIf="farmPondApplicatonFormControls.tankType.errors.required">
            {{'TANK_TYPE_IS_REQUIRED'| translate}}
          </div>
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'SIZE_COVERAGE_AREA'| translate}}</label>
        <p-dropdown [options]="tankListMaster" (onChange)="onCoverageAreaSelected($event)"
          formControlName="sizeCoverageArea" optionLabel="Coverage_Area" placeholder="{{'SELECT_COVERAGE_AREA'| translate}}" 
          [(ngModel)]="coverageAreaSelected" [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedPondApplicatonForm && coverageAreaSelected?.Tank_ID == undefined || farmPondApplicatonFormControls.sizeCoverageArea.touched && coverageAreaSelected?.Tank_ID == undefined}"> 
        </p-dropdown>
        <div *ngIf="isSubmittedPondApplicatonForm && coverageAreaSelected?.Tank_ID == undefined || farmPondApplicatonFormControls.sizeCoverageArea.touched && coverageAreaSelected?.Tank_ID == undefined"
          class="invalid-feedback">
          <div>
            {{'SIZE_COVERAGE_AREA_IA_REQUIRED'| translate}}
          </div>
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'TOP'| translate}}</label>
        <input readonly formControlName="topSize" pInputText id="tankId" type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'BOTTOM'| translate}}</label>
        <input readonly formControlName="bottomSize" pInputText id="latitude" type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'DEPTH_FT'| translate}}</label>
        <input readonly formControlName="depth" pInputText id="longitude" type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'WATER_CAPACITY_IN'| translate}}</label>
        <input readonly formControlName="waterCapacity" pInputText id="canalName" type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'COST_CALCULATION_HSR'| translate}}</label>
        <input readonly formControlName="tenativeCost" pInputText id="canalName" type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'ACTUAL_SUBSIDY_AMOUNT_COMMUNITY_TANK'| translate}}</label>
        <input readonly formControlName="communityActualSubsidy" pInputText id="canalName" type="text" />
      </div>
      <!-- <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'COMMUNITY_TANK_COST'| translate}}</label>
        <input readonly formControlName="communityPayment" pInputText id="canalName" type="text" />
      </div> -->
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'ACTUAL_SUBSIDY_AMOUNT_INDIVIDUAL_TANK'| translate}}</label>
        <input readonly formControlName="individualActualSubsidy" pInputText id="canalName" type="text" />
      </div>
      <!-- <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'INDIVIDUAL_TANK_COST'| translate}}</label>
        <input readonly formControlName="individualPayment" pInputText id="canalName" type="text" />
      </div> -->

      <!-- <div class="field col-12 md:col-4">
          <label htmlFor="waterSourceType">Select Name of Water Course/Outlet No.
          </label>
          <p-dropdown [options]="miList" formControlName="waterCourseName" optionLabel="name" optionValue="name"
            placeholder="select name of water course"></p-dropdown>
        </div>

        <div class="field col-12 md:col-4" *ngIf="applicationSelected === 'WUA'">
          <label htmlFor="waterSourceType">is W.U.A. Formed</label>
          <div class="formgroup-inline">
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="isWUAFormed" value="M" id="IsSubsidyAvailabeYes"></p-radioButton>
                <label for="IsSubsidyAvailabeYes">Yes</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="isWUAFormed" value="F" id="IsSubsidyAvailabeNo"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">No</label>
              </div>
            </div>
          </div> -->

      <!-- <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
              <div *ngIf="farmersFormControls.farmersName.errors.required">Farmer Name is required</div>
            </div> -->
      <!-- </div> -->

      <!-- <div class="field col-12 md:col-4">
          <label htmlFor="waterSourceType">Outlet RD/Name</label>
          <input formControlName="outletName" pInputText id="outletName" type="text" />
        </div>
        <div class="field col-12 md:col-4" *ngIf="applicationSelected === 'WUA'">
          <label htmlFor="waterSourceType">W.U.A. Regd. No</label>
          <input formControlName="wuaRegdNo" pInputText id="wuaRegdNo" type="text" />
        </div>
        <div class="field col-12 md:col-4" *ngIf="applicationSelected === 'WUA'">
          <label htmlFor="waterSourceType">W.U.A. Name</label>
          <input formControlName="wuaName" pInputText id="wuaName" type="text" />
        </div>

        <div class="field col-12 md:col-4" *ngIf="applicationSelected === 'WUA'">
          <label htmlFor="block">W.U.A. Date of Regd.</label>
          <p-calendar [showIcon]="true" [showButtonBar]="true" formControlName="wuaDateRegd"></p-calendar>
        </div>

        <div class="field col-12 md:col-4" *ngIf="applicationSelected === 'WUA'">
          <label htmlFor="farmerName">W.U.A. CCA</label>
          <input formControlName="WUAcca" pInputText id="WUAcca" type="text" />
        </div> -->

      <!-- </div> -->
    </form>
    <!-- </div> -->
  </div>

  <div class="card" reflow="true" *ngIf="componentSelected?.Component?.includes('Solar')">
    <h5>{{'SOLAR_PUMP_DETAIL'| translate}}</h5>
    <!-- <div class="p-fluid p-formgrid grid"> -->
    <form [formGroup]="solarApplicatonForm" class="p-fluid p-formgrid grid">
      <!-- <div class="col-12 flex-wrap" > -->
      <!-- <div class="field col-12 md:col-4">
          <label htmlFor="waterSourceType">MI </label>
          <p-dropdown [options]="miList" formControlName="component" optionLabel="name"
            placeholder="select a component"></p-dropdown>

        </div> -->
      <!-- <div class="field col-12 md:col-4">
          <label htmlFor="waterSourceType">Vendor </label>
          <p-dropdown [options]="miList" formControlName="component" optionLabel="name"
            (onChange)="onComponentSelected($event)" placeholder="select a vendor"></p-dropdown>
        </div> -->
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'LAND_ID_'| translate}}</label>
        <p-dropdown [options]="landIDList" formControlName="landId" optionLabel="displayName" optionValue="LandID"
          placeholder="{{'SELECT_LAND_IDS'| translate}}" (onChange)="onSolarLandIdSelected($event)" [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedSolarApplicatonFrom && solarApplicatonFormControls.landId.errors || solarApplicatonFormControls.landId.touched && solarApplicatonFormControls.landId.errors}"></p-dropdown>
        <div *ngIf="isSubmittedSolarApplicatonFrom && solarApplicatonFormControls.landId.errors || solarApplicatonFormControls.landId.touched && solarApplicatonFormControls.landId.errors"
          class="invalid-feedback">
          <div *ngIf="solarApplicatonFormControls.landId.errors.required">
            {{'LAND_ID_IS_REQUIRED'| translate}}
          </div>
        </div>
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'PUMP_CONTROLLER_TYPE'| translate}}</label>
        <div class="formgroup-inline">
          <div class="field">
            <div class="field-radiobutton mb-0">
              <p-radioButton formControlName="controlType" value="Normal" id="IsSubsidyAvailabeYes"
                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
              <label for="IsSubsidyAvailabeYes">{{'NORMAL_SOLAR_PUMP_COMTROLLER'| translate}}</label>
            </div>
          </div>
          <div class="field">
            <div class="field-radiobutton mb-0">
              <p-radioButton formControlName="controlType" value="Universial" id="IsSubsidyAvailabeNo"
                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
              <label for="IsSubsidyAvailabeNo">{{'UNIVERSAL_SOLAR_PUMP_CONTROLLER'| translate}}</label>
            </div>
          </div>
        </div>

        <!-- <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
              <div *ngIf="farmersFormControls.farmersName.errors.required">Farmer Name is required</div>
            </div> -->
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'PUMP_TYPE'| translate}}</label>
        <div class="formgroup-inline">
          <div class="field">
            <div class="field-radiobutton mb-0">
              <p-radioButton formControlName="pump" value="Surface" id="IsSubsidyAvailabeYes"
                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
              <label for="IsSubsidyAvailabeYes">{{'SURFACE_PUMP'| translate}}</label>
            </div>
          </div>
          <div class="field">
            <div class="field-radiobutton mb-0">
              <p-radioButton formControlName="pump" value="Submersible" id="IsSubsidyAvailabeNo"
                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
              <label for="IsSubsidyAvailabeNo">{{'SUBMERSIBLE_PUMP'| translate}}</label>
            </div>
          </div>
        </div>

        <!-- <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
              <div *ngIf="farmersFormControls.farmersName.errors.required">Farmer Name is required</div>
            </div> -->
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'SOLAR_PUMP_CATEGORY'| translate}}</label>
        <div class="formgroup-inline">
          <div class="field">
            <div class="field-radiobutton mb-0">
              <p-radioButton formControlName="pumpType" value="AC" id="IsSubsidyAvailabeYes"
                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
              <label for="IsSubsidyAvailabeYes">{{'AC'| translate}}</label>
            </div>
          </div>
          <div class="field">
            <div class="field-radiobutton mb-0">
              <p-radioButton formControlName="pumpType" value="DC" id="IsSubsidyAvailabeNo"
                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
              <label for="IsSubsidyAvailabeNo">{{'DC'| translate}}</label>
            </div>
          </div>
        </div>

        <!-- <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
              <div *ngIf="farmersFormControls.farmersName.errors.required">Farmer Name is required</div>
            </div> -->
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="waterSourceType">{{'CAPACITY_OF_SOLAR_PUMP'| translate}} </label>
        <p-dropdown [options]="pumpCapacityList" formControlName="pumpCapacity" optionLabel="Pump_Capacity" optionValue="Pump_Capacity"
          (onChange)="onCapacityOfPumpSelected($event)" placeholder="{{'SELECT_A_CAPACITY'| translate}}"></p-dropdown>

        <!-- <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
              <div *ngIf="farmersFormControls.farmersName.errors.required">Farmer Name is required</div>
            </div> -->
      </div>

      <div class="field col-12 md:col-4" *ngIf="primarySolarVendorList.length">
        <label htmlFor="waterSourceType">{{'PRIMARY_VENDOR'| translate}} </label>
        <p-dropdown [options]="primarySolarVendorList" formControlName="primaryVendor" optionLabel="Primary_Vendor"
          optionValue="Primary_Vendor" placeholder="{{'SELECT_A_PRIMARY'}}"
          (onChange)="onPrimarySolarVendorChange($event)" [(ngModel)]="selectedPrimarySolarVendor"></p-dropdown>

        <!-- <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
              <div *ngIf="farmersFormControls.farmersName.errors.required">Farmer Name is required</div>
            </div> -->
      </div>
      <div class="field col-12 md:col-4" *ngIf="secondarySolarVendorList.length">
        <label htmlFor="waterSourceType">{{'SECONDARY_VENDOR'| translate}} </label>
        <p-dropdown [options]="secondarySolarVendorList" formControlName="secondaryVendor"
          optionLabel="Secondary_Vendor" optionValue="Secondary_Vendor" [(ngModel)]="selectedSecondarySolarVendor"
          placeholder="{{'SELECT_A_SECONDARY'}}" (onChange)="onSecondarySolarVendorChange($event)"></p-dropdown>

        <!-- <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
              <div *ngIf="farmersFormControls.farmersName.errors.required">Farmer Name is required</div>
            </div> -->
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="farmerName">{{'FARMER_SHARE_TOTAL'| translate}}</label>
        <input formControlName="farmerShare" readonly pInputText id="farmerName" type="text" />
      </div>

      <!-- </div> -->
    </form>
    <!-- </div> -->

  </div>
  <!-- *ngIf="componentSelected.Component.includes('Water_Course')" -->

  

  <div class="card" reflow="true"
    *ngIf="componentSelected?.Component?.includes('Solar') || componentSelected?.Component?.includes('Tank')|| componentSelected?.Component?.includes('MI')">
    <h5>{{'SELECT_BENEFICIARY_BANK'| translate}}</h5>
    <p-dropdown class="w-100" [options]="bankAccountList" optionLabel="displayName" optionValue="Account_NO"
      (onChange)="onBankAccountSelected($event)" placeholder="{{'SELECT_A_BANK_ACCOUNT'| translate}}" [(ngModel)]="bankAccountSelected">
    </p-dropdown>

  </div>
  <div class="card" reflow="true">
    <button (click)="onFarmersApplicationFormSubmit()" pButton pRipple type="button" label="{{'SAVE' | translate}}"
      class="p-button-success mr-2 mb-2 mt-2"
      [disabled]="componentSelected == undefined || componentSelected == null || isTargetReached "></button>
    <!-- <button pButton pRipple label="Download Consent" *ngIf="applicationSelected === 'Group'" class="p-button-success mr-2 mb-2 mt-2" (click)="downloadConsent()"></button> -->

  </div>
</div>

<!-- dialog to add micomponent -->
<p-dialog [baseZIndex]="-100" [(visible)]="addBankDialog" [style]="{ width: '1000px', height: '700px' }" header="{{'ADD_MI_DETAILS'| translate}}"
  [modal]="true" styleClass="p-fluid" [baseZIndex]="-100">
  <ng-template pTemplate="content">
    <form [formGroup]="miApplicatonForm">

      <div class="grid p-fluid">
        <div class="field col-12">
          <label htmlFor="state">{{'SUBSIDY_ALREADY_TAKEN_FORM_DEPARTMENT'| translate}}</label>
          <p-table [value]="farmerPreviousSubsidies" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>{{'APP_ID'| translate}}</th>
                <th>{{'DEPARTMENT'| translate}}</th>
                <th>{{'AREA'| translate}}</th>
                <th>{{'SUBSIDY_YEAR'| translate}}</th>
                <th>{{'AADHAR_NUMBER'| translate}}</th>
                <th>{{'SYSTEM'| translate}}</th>
                <th>{{'LAND_DETAILS'| translate}}</th>
                <th>{{'DIFF_YEAR'| translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-subsidy>
              <tr>
                <td>{{subsidy.AppId}}</td>
                <td>{{subsidy.Department}}</td>
                <td>{{subsidy.Area | number : '1.2-2'}}</td>
                <td>{{subsidy.SubsidyYear}}</td>
                <td>{{subsidy.AadharNo}}</td>
                <td>{{subsidy.System}}</td>
                <td>{{subsidy.LandDetail}}</td>
                <td>{{subsidy.DiffYear}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10">{{'NO_RECORDS_TO_SHOW'| translate}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>


      <div class="field">
        <label htmlFor="waterSourceType">{{'LAND_ID_'| translate}}</label>
        <p-dropdown [options]="landIDList" formControlName="landId" optionLabel="displayName" optionValue="LandID"
          placeholder="{{'SELECT_LAND_IDS'| translate}}" optionDisabled="isDifferentFarmerLand"></p-dropdown>

      </div>

      <div class="field">
        <label htmlFor="waterSourceType">{{'MI'| translate}} </label>
        <p-dropdown [options]="miList" formControlName="mi" optionValue="Program_Id" optionLabel="Program_Name"
          [(ngModel)]="selectedMI" placeholder="{{'SELECT_A_COMPONENT'| translate}}" (onChange)="onSelectMI()">
        </p-dropdown>
      </div>
      <div class="field">
        <label htmlFor="waterSourceType">{{'VENDOR'| translate}} </label>
        <!-- <p-dropdown [options]="vendorList.Name" formControlName="vendor" optionLabel="Vendor_Code" optionValue="Vendor_Code" placeholder="select a vendor">
        </p-dropdown> -->
        <p-autoComplete placeholder="Vendor Search" id="dd" [dropdown]="true" [multiple]="false" [disabled]="isDisabled" optionLabel="Name" optionValue="Vendor_Code"
          formControlName="vendor" [suggestions]="filteredmiVendorList" (completeMethod)="filterMIVendor($event)"
          field="Name" (onSelect)="onVendorSelect($event)" [(ngModel)]="miSelectedVendor"></p-autoComplete>

      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text" (click)="saveProduct()"></button>
  </ng-template>
</p-dialog>


<!-- dialog to add farmers in group -->
<p-dialog [(visible)]="addFarmerGroupDialog" [style]="{ width: '75%' }" header="Farmers Details" [modal]="true"
  styleClass="p-fluid">
  <p-table #dt [value]="farmerDetailsList" dataKey="Farmer_ID" responsiveLayout="scroll"
    [(selection)]="selectedFarmerLandDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[
    'Name',
    'Father_name',
    'Mother_Name',
    'PPP_ID',
    'Aadhar_No',
    'Mobile',
    'Address'
  ]">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
            placeholder="{{'SEARCH'| translate}}" />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 1rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th style="width: 1rem"></th>
        <th pSortableColumn="Name">{{'NAME'| translate}} <p-sortIcon field="Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Father_name">{{'FATHER_NAME'| translate}} <p-sortIcon field="Father_name"></p-sortIcon>
        </th>
        <th pSortableColumn="Mother_Name">{{'MOTHER_NAME'| translate}} <p-sortIcon field="Mother_Name"></p-sortIcon>
        </th>
        <th pSortableColumn="PPP_ID">{{'PPP_ID'| translate}} <p-sortIcon field="PPP_ID"></p-sortIcon>
        </th>
        <th pSortableColumn="Aadhar_No">{{'AADHAR_NO'| translate}} <p-sortIcon field="Aadhar_No"></p-sortIcon>
        </th>
        <th pSortableColumn="Village_Code">{{'VILLAGE'| translate}}<p-sortIcon field="Village_Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Mobile">{{'MOBILE_NO'| translate}} <p-sortIcon field="Mobile"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-expanded="expanded">
      <tr>
        <td>
          <p-tableCheckbox [value]="product"></p-tableCheckbox>
        </td>
        <td>
          <button type="button" pButton pRipple [pRowToggler]="product"
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        <td style="min-width: 12rem;">{{product.Name}}</td>
        <td style="min-width: 8rem;">{{product.Father_name}}</td>
        <td style="min-width: 10rem;">{{product.Mother_Name}}</td>
        <td style="min-width: 10rem;">{{product.PPP_ID}}</td>
        <td style="min-width: 8rem;">{{product.Aadhar_No}}</td>
        <td style="min-width: 10rem;">{{product.Village_Code}}</td>
        <td style="min-width: 10rem;">{{product.Mobile}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
      <tr>
        <td colspan="7">
          <div class="p-3">
            <p-table [value]="product.landDetails" dataKey="Land_ID" responsiveLayout="scroll">
              <ng-template pTemplate="header">
      <tr>
        <th style="width: 1rem">
          <p-tableHeaderCheckbox (click)="selectHeaderRow(headerRow.checked, product.landDetails)" #headerRow>
          </p-tableHeaderCheckbox>
        </th>
        <th pSortableColumn="Land_ID">{{'LAND_ID_'| translate}}<p-sortIcon field="Land_ID"></p-sortIcon>
        </th>
        <th pSortableColumn="Morabba_No">{{'MORABBA_NO'| translate}}<p-sortIcon field="Morabba_No"></p-sortIcon>
        </th>
        <th pSortableColumn="Killa_No">{{'KILLA_NO'| translate}} <p-sortIcon field="Killa_No"></p-sortIcon>
        </th>
        <th pSortableColumn="Kanals">{{'KANALS'| translate}} <p-sortIcon field="Kanals"></p-sortIcon>
        </th>
        <th pSortableColumn="Village_Code">{{'VILLAGE'| translate}}<p-sortIcon field="Village_Code"></p-sortIcon>
        </th>
        <th style="width: 4rem"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order>
      <tr>
        <td>
          <p-tableCheckbox [value]="order" (click)="selectRow(e.checked, order)" #e></p-tableCheckbox>
        </td>
        <td>{{order.Land_ID}}</td>
        <td>{{order.Morabba_No}}</td>
        <td>{{order.Killa_No}}</td>
        <td>{{order.Kanals}}</td>
        <td>{{order.Village_Code}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">{{'THERE_ARE_NO_LAND_FOR_THIS_FARMER'| translate}}.</td>
      </tr>
    </ng-template>
  </p-table>
  </div>
  </td>
  </tr>
  </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text"
      (click)="hideFarmersAddToGroupDialog()"></button>
    <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text"
      (click)="saveFarmerToGroup()"></button>
  </ng-template>
</p-dialog>
<p-confirmDialog [style]="{ width: '400px' }"></p-confirmDialog>